module.exports = __webpack_public_path__ + "static/0058-39ce7739deb4d4761548a90ea920a703.png";